// extracted by mini-css-extract-plugin
export default {"root":"error-module--root--poekD","header":"error-module--header--fktFl","button":"error-module--button--hbdLG","desc":"error-module--desc--YuK_6"};